// getJsEnvironment.js
'use strict';

export const getIsInBrowserMainThread = () =>
  typeof Window === 'function' && globalThis instanceof Window;

export const getIsInServiceWorker = () =>
  typeof self !== 'undefined' &&
  typeof self.ServiceWorkerGlobalScope !== 'undefined';

export const getIsInBrowser = () =>
  getIsInBrowserMainThread() || getIsInServiceWorker();

export const getIsInIframe = () => {
  if (getIsInNode() || getIsInServiceWorker()) return false;

  // refer to: https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const getIsInNode = () =>
  typeof process !== 'undefined' && process.release?.name === 'node';
